import {
  AssetRecomInterface,
  SparkLineInterface,
} from '../interfaces/asset-recom.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SparkLine')
export class SparkLine implements SparkLineInterface {
  @JsonProperty('Date', String, true)
  date: string = undefined;

  @JsonProperty('Value', Number, true)
  value: number = undefined;
}

@JsonObject('AssetRecom')
export class AssetRecom implements AssetRecomInterface {
  @JsonProperty('AssetCode', String, true)
  assetCode: string = undefined;

  @JsonProperty('AssetId', String, true)
  assetId: string = undefined;

  @JsonProperty('AssetName', String, true)
  assetName: string = undefined;

  @JsonProperty('Behavior', String, true)
  behavior: string = undefined;

  @JsonProperty('Category', String, true)
  category: string = undefined;

  @JsonProperty('Change', Number, true)
  change: number = undefined;

  @JsonProperty('ChangeP', Number, true)
  changeP: number = undefined;

  @JsonProperty('Currency', String, true)
  currency: string = undefined;

  @JsonProperty('Exchange', String, true)
  exchange: string = undefined;

  @JsonProperty('IsFavorite', Boolean, true)
  isFavorite: boolean = undefined;

  @JsonProperty('ISIN', String, true)
  isin: string = undefined;

  @JsonProperty('LastDate', String, true)
  lastDate: string = undefined;

  @JsonProperty('LastPrice', Number, true)
  lastPrice: number = undefined;

  @JsonProperty('Perf1Year', Number, true)
  perf1Year: number = undefined;

  @JsonProperty('Score', Number, true)
  score: number = undefined;

  @JsonProperty('TrendText', String, true)
  trendText: string = undefined;

  @JsonProperty('Trend1', Number, true)
  trend1: number = undefined;

  @JsonProperty('Trend2', Number, true)
  trend2: number = undefined;

  @JsonProperty('Trend3', Number, true)
  trend3: number = undefined;

  @JsonProperty('Volatility', Number, true)
  volatility: number = undefined;

  @JsonProperty('SparkLine', [SparkLine], true)
  sparkLine: SparkLineInterface[] = undefined;
}

/*
@JsonObject('AssetsRecomResponse')
export class AssetsRecomResponse implements AssetsRecomInterface {
  @JsonProperty('Assets', [AssetRecom], true)
  assets: AssetRecomInterface[];
}

*/
